module.exports = __webpack_public_path__ + "static/media/nb_akademie_medium-webfont.67a2b8f3.ttf";